import React, { useState } from 'react';
import Navbar from '../../components/navbar';
import Footer from '../../components/footer';
import Profile from '../../components/profile';

import Notification from "../../components/Notification";
import Trolly from "../../components/Trolly";
import LoadingScreen from "../../components/LoadingScreen";
import Alert from "../../components/Alert";
import { useNavigate } from "react-router-dom";
import { useCookies } from 'react-cookie';
import "../../css/checkout.css"

export default function Checkout() {
  const [userData, setUser] = React.useState({});
  const navigate = useNavigate();
  const [cookies, setCookie] = useCookies(['accessToken']);
  const [isLoading, setIsLoading] = useState(false);
  const [alertActive, setAlertActive] = useState(true);
  const [alert, setAlert] = useState({});
  const [wishlist, setWishlist] = useState([]);

  // const [message, setmessage] = useState(
  
  // );

  const checkout = [];
  let totalHargaProduk = 0
  let totalOngkir = 0
  let totalBiayaAdmin = 0
  let totalHarga = 0

  const activateAlert = () => {
    setAlertActive(true);
    setTimeout(() => {
      setAlertActive(false);
    }, 3000);
  };

  const rupiah = (number) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
    }).format(number);
  };

  React.useEffect(() => {
    const handleGetWishlist = async () => {
      setIsLoading(true);
      try {
        const url = `https://w-shop-backend.vercel.app/api/wishlist`;
        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + cookies.accessToken,
          },
        });
        const body = await response.json();
        if (body.status !== "success") {
          throw new Error(body.message);
        } else {
          setWishlist(body.data);
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
        setAlert({
          type: "danger",
          message: "Error: " + error.message,
        });
        activateAlert();
      }
    };

    handleGetWishlist()
  }, [cookies.accessToken, navigate, setCookie])


  wishlist.map((wish) =>
  (wish.wishlist.status === 'checkout' ?
    (totalHargaProduk += (wish.price * wish.wishlist.amount),
      totalOngkir += wish.ongkir,
      totalBiayaAdmin += 1000,
      totalHarga += ((wish.price * wish.wishlist.amount) + wish.ongkir + 1000),  
      checkout.push({ productId: wish.id, amount: wish.wishlist.amount, id: wish.wishlist.id, priceTotal: ((wish.price * wish.wishlist.amount) + wish.ongkir + 1000), message:wish.wishlist.message })
    ) : (
      null
    ))
  )

  const handlCreateTransaction = async () => {
    setIsLoading(true);
    try {
      if (userData.saldo < totalHarga) {
        throw new Error('Saldo anda tidak cukup')
      } else if (checkout.length < 1) {
        throw new Error('Tidak ada produk yang dipilih')
      }
      for (let index = 0; index < checkout.length; index++) {
        const url = `https://w-shop-backend.vercel.app/api/transactions`;
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + cookies.accessToken,
          },
          body: JSON.stringify({ productId: checkout[index].productId, amount: checkout[index].amount, priceTotal: checkout[index].priceTotal, message:checkout[index].message }),
        });
        const body = await response.json();
        if (body.status !== "success") {
          throw new Error(body.message);
        } else {
          const url1 = `https://w-shop-backend.vercel.app/api/products/${checkout[index].productId}/wishlist`;
          const response1 = await fetch(url1, {
            method: "DELETE",
            headers: {
              "Content-type": "application/json",
              Authorization: "Bearer " + cookies.accessToken,
            },
          });
          const body = await response1.json();
          if (body.status !== "success") {
            throw new Error(body.message);
          }
        }

      }
      const event = {
        type: "alert",
        alert: {
          type: "success",
          message: "Produk ditambahkan ke keranjang",
        },
      };

      activateAlert();
      setIsLoading(false);
      setTimeout(() => {
        navigate('/home')
      }, 200);
    } catch (error) {
      setIsLoading(false);
      setAlert({
        type: "danger",
        message: "Error: " + error.message,
      });
      activateAlert();
    }
  };

  const handleUpdateWishlist = async () => {
    setIsLoading(true);
    try {
      for (let index = 0; index < checkout.length; index++) {
        const url = `https://w-shop-backend.vercel.app/api/wishlist`;
        const response = await fetch(url, {
          method: 'PUT',
          headers: {
            'Content-type': 'application/json',
            'Authorization': 'Bearer ' + cookies.accessToken,
          },
          body: JSON.stringify({ id: checkout[index].id, status: 'wishlist' }),
        });
        const body = await response.json();
        if (body.status !== 'success') {
          throw new Error(body.message,);
        }
      }
      setIsLoading(false)
      navigate('/trolly')
    } catch (error) {
      setIsLoading(false);
      setAlert({
        type: 'danger',
        message: 'Error: ' + error.message,
      })
      activateAlert();
    }
  }


  console.log(checkout);
  console.log(wishlist);
  // console.log(userData);

  return (

    <div>
      <LoadingScreen active={isLoading} />
      <Alert active={alertActive} type={alert.type} message={alert.message} />
      <Navbar
      userData={setUser}
        logReg={<Profile userData={userData} />}
        notification={<Notification />}
        trolly={<Trolly />}
      />
      <div className='main'>
        <div className='container py-5'>
          <div className='p-3' style={{ backgroundColor: "white", borderTop: "dashed", }}>
            <div className=' d-flex ' >
              <img alt='' src='/img/location.png' style={{ width: 35, height: 35 }} />
              <h1 className='titAlamat'>Alamat Pengiriman</h1>
            </div>
            <table className="table table-borderless mt-4">
              <tbody>
                <tr>
                  <td className='alpeng'>Nama</td>
                  <td className='alamatCheckout'>{userData.address}, {userData.provinces}</td>
                </tr>
                <tr>
                  <td className='alpeng'>No Hp</td>
                  <td className='alamatCheckout'>{userData.phoneNumber}</td>
                </tr>
              </tbody>
            </table>
            <div className='row mt-4'>
              <div className='col col-lg-3'>


              </div>
              <div className='col col-lg-9'>

              </div>
            </div>
          </div>

          {wishlist.map((wish, index) => (
            wish.wishlist.status === 'checkout' ? (
              <div key={index} className='py-3 px-5 my-3 mb-5 ' style={{ backgroundColor: "white" }}>
                <p className='titShop '>{wish.shop.shopName}</p><hr />
                <div className=' py-3 d-sm-flex d-block'>
                  <div className=' d-flex produk'>
                    <img alt='' src={wish.imgUrl} className=' ' width={48} height={46} />
                    <p className=' ms-2 '>{wish.product}</p>
                  </div>
                  <div className='tothar ms-sm-0 ms-2'>{rupiah(wish.price)}</div>
                  <div className='tothar ms-sm-0 ms-2'>x {wish.wishlist.amount}</div>
                  <div className='tothar ms-sm-auto ms-2 text-sm-end text-start'>{rupiah(wish.price * wish.wishlist.amount)}</div>
                </div>
                <div className='row py-3 ms-1 mb-3' style={{ backgroundColor: "rgba(227, 227, 227, 0.5)" }}>
                  <div className='col-6 ms-auto text-end'>
                    <p className='bOng'>Biaya Ongkir</p>
                    <p className='bOng'>Total Pesanan</p>
                  </div>
                  <div className='col-6 text-end'>
                    <p>{rupiah(wish.ongkir)}</p>
                    <p className='totPes'>{rupiah((wish.price * wish.wishlist.amount) + wish.ongkir)}</p>
                  </div>
                </div>
                <div className=' my-3 mt-4'>
                  <hr className=' mt-3' />
                  <p className='mt-3'>Pesan</p>
                  <div className=" w-100 mb-5 px-3 pt-4">
                    <p type="text" className="w-100 border-0 border-bottom" style={{ outline: "0", border: "dashed" }} >{wish.wishlist.message}</p>
                  </div>
                </div>
              </div>
            ) :
              <div key={index}></div>
          ))}

          <div className=' py-5 px-5' style={{ backgroundColor: "white" }}>
            <table className="table text-end table-borderless">
              <tbody >
                <tr className='p-0' >
                  <td> <p className='ckLeft' >Sub Total Untuk Produk</p></td>
                  <td> <p className='ckRight' >{rupiah(totalHargaProduk)}</p></td>
                </tr>
                <tr>
                  <td > <p className='ckLeft'>Total Ongkos Kirim</p></td>
                  <td><p className='ckRight'>{rupiah(totalOngkir)}</p></td>
                </tr>
                <tr>
                  <td ><p className='ckLeft'>Biaya Admin</p></td>
                  <td><p className='ckRight'>{rupiah(totalBiayaAdmin)}</p></td>
                </tr>
                <tr>
                  <td ><p className='ckLeft'>Total Pembayaran</p></td>
                  <td><p className='ck'>{rupiah(totalHarga)}</p></td>
                </tr>
              </tbody>
            </table>
            <div className='ms-auto' style={{ width: "420px" }}>
              <button className='bPesanan mt-3 btn btn-outline-primary me-3' onClick={() => (handleUpdateWishlist())}>Batal</button>
              <button className='bPesanan mt-3 btn btn-primary' onClick={() => (handlCreateTransaction())}>Buat Pesanan</button>
            </div>
          </div>

        </div>
      </div>
      <Footer />
    </div>
  );
}
